import { useSelector } from 'react-redux';
import betslip from '@gin-betting/betslip';
import { createSelector } from 'reselect';

import { State } from 'types';

const {
    selectors: { selectInitialBetslipBet, selectChosenBetslipBetId },
} = betslip;

type Output = {
    betslipOddId: string;
    betslipBetId: string;
    count: number;
    chosenBetslipBetId: string | null;
} | null;

const selectProps = createSelector(
    selectInitialBetslipBet,
    selectChosenBetslipBetId,
    (initialBetslipBet, chosenBetslipBetId): Output | null => {
        if (!initialBetslipBet) return null;

        const { betslipOddIds, id: betslipBetId } = initialBetslipBet;

        const betslipOddId = betslipOddIds.first<string | undefined>();

        const count = betslipOddIds.count();

        if (!betslipOddId) return null;

        return {
            betslipOddId,
            betslipBetId,
            count,
            chosenBetslipBetId,
        };
    }
);

export type ValidQuickBetslipProps = NonNullable<Output>;

const useValidQuickBetslipProps = (): Output => {
    const props = useSelector((s: State) => selectProps(s));

    return props;
};

export default useValidQuickBetslipProps;
